import { render } from "./saveIcon.svg?vue&type=template&id=203bda18"
const script = {}
script.render = render

export default script